import { writable } from "svelte/store";

export const reveal = writable(null);

